<template>
  <div>
    <table class="asd-table">
      <thead>
        <tr class="table-heading">
          <th>
            <button class="asd-btn-confirm"
                    @click="createState"
            >
              <i class="fas fa-plus-square"></i>
            </button>
          </th>
          <th>
            {{ $t('common.name') }}
          </th>
          <th>Obsahuje stavy</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(g, id) in graphs"
            :key="id"
        >
          <td class="asd-btn-group">
            <button v-help.mouse="`Editovat`"
                    type="button"
                    class="asd-btn-edit"
                    @click="$router.push({name: 'settingsStatesDetail', params: {id: id}})"
            >
              <i class="fas fa-pencil-alt"></i>
            </button>
          </td>
          <td>{{ g.name }}</td>
          <td class="properties-names">
            <span v-for="(s, $index) in g.states"
                  :key="$index"
            >
              {{
                (s && s.label) ? s.label : 'Nedefinováno'
              }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { get, map, mapValues, find, cloneDeep } from 'lodash'
import uuid from 'uuid'

export default {
    name: 'EntityStatesSettingsTable',
    components: {
    },
    computed: {
        graphs() {
            const states = get(this.$store.getters.settings, 'entity-states.states', [])
            return mapValues(cloneDeep(get(this.$store.getters.settings, 'entity-states.graphs', [])), g => {
                g.states = map(g.states, sid => find(states, ['id', sid]))
                return g
            })
        },
    },
    methods: {
        createState() {
            this.$router.push({ name: 'settingsStatesDetail', params: { id: uuid() } })
        },
    },
}
</script>
